const config = {};
let _env = process.env.VUE_APP_ENV;
/**
 * 配置各个环境网关地址
 * @param {string} env
 */
export const setConst = (env) => {
  _env = env;
  config.env = env;
  // 非pro
  config.rongCloudAPPKey = 'lmxuhwaglel6d';
  if (env === 'dev') {
    Object.assign(config, {
      // dev
      // HITCH_REGISTER_API : 'https://dev-hitchregistergw.hellobike.com/api',
      // API : 'https://newdev-api.hellobike.com/api',
      // BACE_API: 'http://yapi.hellobike.cn/mock/1485/12128',
      // ROOT_API: 'https://newdev-taxigw.hellobike.com',
      // HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/dev/latest/index.html',
      // MAIN_HOST_API: 'https://m.hellobike.com/AppHitchMainH5/dev/latest/index.html',
      // UBT_API: 'https://dev-ubt.hellobike.com/yukon_logging',
      // UPLOAD_API: 'https://newdev-api.hellobike.com/api',
      // AUTH_API: 'https://newdev-api.hellobike.com/api',
      // CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/dev/latest/index.html#/?h5Login=1&openType=webview',
      // CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/dev/latest/index.html'
      // fat
      FREE_RIDE_API: 'https://fat-a.hellobike.com/hitch/api',
      HITCH_REGISTER_API: 'https://fat-hitchregistergw.hellobike.com/api',
      API: 'https://fat-api.hellobike.com/api',
      ROOT_API: 'https://fat-taxiapi.hellobike.com',
      TAXI_API: 'https://fat-taxiapi.hellobike.com/api',
      BACE_API: 'https://fat.rapi.ttbike.com.cn/user/notify',
      HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/fat/latest/index.html',
      UBT_API: 'https://fat-ubt.hellobike.com/yukon_logging',
      UPLOAD_API: 'https://fat-api.hellobike.com/api',
      AUTH_API: 'https://fat-api.hellobike.com/auth',
      CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/fat/latest/index.html#/?h5Login=1&openType=webview',
      CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/fat/latest/index.html',
      CS_WEB_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/fat/latest/index.html#/?h5Login=1&openType=webview',
      CS_API_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/fat/latest/index.html',
      ECO_EXPRESS: 'https://fat-ecotaxiapi.hellobike.com/api',
      HITCH_STATION: 'https://fat-spacexapi.hellobike.com/api',
      HITCH_API: 'https://m.hellobike.com/AppHitchDriverApplyH5/fat/latest/index.html',
      ALIPAY_PAY_H5: 'https://m.hellobike.com/AppH5PayPage/dev/latest/index.html',
      APP_RCPDRIVER_EDUCATION_H5: 'https://m.hellobike.com/AppRcpDriverEducationH5/fat/latest/index.html',
      MARKETING_API: 'https://fat-marketingapi.hellobike.com/api',
      LBS_API: 'https://fat-hello-location-based-services.hellobike.com/api',
      APP_AUTH_REBIND_PHONE_H5: 'https://m.hellobike.com/AppAuthH5/latest/index.html#/rebind-phone',
      APP_TRANSFER_H5: 'https://m.hellobike.com/AppHitchMainH5/fat/latest/index.html#/transfer',
      // // uat
      // API: 'https://uat-api.hellobike.com/api',
      // ROOT_API: 'https://uat-taxiapi.hellobike.com',
      // BACE_API: 'https://uat.rapi.ttbike.com.cn/user/notify',
      // HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/uat/latest/index.html',
      // UBT_API: 'https://uat-ubt.hellobike.com/yukon_logging',
      // UPLOAD_API: 'https://uat-api.hellobike.com/api',
      // AUTH_API: 'https://uat-api.hellobike.com/auth'
      // CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/uat/latest/index.html#/?h5Login=1&openType=webview',
      // CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/uat/latest/index.html'
      // ECO_EXPRESS: 'https://uat-ecotaxiapi.hellobike.com/api',
      // HITCH_STATION: 'https://uat-spacexapi.hellobike.com/api',
      // pro
      // API: 'https://api.hellobike.com/api',
      // ROOT_API: 'https://taxiapi.hellobike.com',
      // BACE_API: 'https://rapi.ttbike.com.cn/user/notify',
      // HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/latest/index.html',
      // UBT_API: 'https://ubt.hellobike.com/yukon_logging',
      // UPLOAD_API: 'https://api.hellobike.com/api',
      // AUTH_API: 'https://api.hellobike.com/auth'
      // CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/latest/index.html#/?h5Login=1&openType=webview',
      // CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/latest/index.html',
      // ECO_EXPRESS: 'https://ecotaxiapi.hellobike.com/api',
      // HITCH_STATION: 'https://spacexapi.hellobike.com/api',
    });
  } else if (env === 'fat' || env === 'fat_2' || env === 'fat:tag=fat') {
    Object.assign(config, {
      FREE_RIDE_API: 'https://fat-a.hellobike.com/hitch/api',
      HITCH_REGISTER_API: 'https://fat-hitchregistergw.hellobike.com/api',
      API: 'https://fat-api.hellobike.com/api',
      ROOT_API: 'https://fat-taxiapi.hellobike.com',
      TAXI_API: 'https://fat-taxiapi.hellobike.com/api',
      BACE_API: 'https://fat.rapi.ttbike.com.cn/user/notify',
      HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/fat/latest/index.html',
      MAIN_HOST_API: 'https://m.hellobike.com/AppHitchMainH5/fat/latest/index.html',
      MAIN_H5_PR_IM: 'https://m.hellobike.com/AppHitchMainH5/fat/latest/pr_index_super-im.html',
      UBT_API: 'https://fat-ubt.hellobike.com/yukon_logging',
      UPLOAD_API: 'https://fat-api.hellobike.com/api',
      AUTH_API: 'https://fat-api.hellobike.com/auth',
      CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/fat/latest/index.html#/?h5Login=1&openType=webview',
      CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/fat/latest/index.html',
      CS_WEB_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/fat/latest/index.html?h5Login=1&openType=webview',
      CS_API_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/fat/latest/index.html',
      HITCH_API: 'https://m.hellobike.com/AppHitchDriverApplyH5/fat/latest/index.html',
      ECO_EXPRESS: 'https://fat-ecotaxiapi.hellobike.com/api',
      HITCH_STATION: 'https://fat-spacexapi.hellobike.com/api',
      rongCloudAPPKey: 'lmxuhwaglel6d',
      APP_RCPDRIVER_EDUCATION_H5: 'https://m.hellobike.com/AppRcpDriverEducationH5/fat/latest/index.html',
      ALIPAY_PAY_H5: 'https://m.hellobike.com/AppH5PayPage/fat/latest/index.html',
      MARKETING_API: 'https://fat-marketingapi.hellobike.com/api',
      LBS_API: 'https://fat-hello-location-based-services.hellobike.com/api',
      APP_AUTH_REBIND_PHONE_H5: 'https://m.hellobike.com/AppAuthH5/fat/latest/index.html#/rebind-phone',
      APP_TRANSFER_H5: 'https://m.hellobike.com/AppHitchMainH5/fat/latest/index.html#/transfer',
    });
  } else if (env === 'uat') {
    Object.assign(config, {
      FREE_RIDE_API: 'https://uat-a.hellobike.com/hitch/api',
      HITCH_REGISTER_API: 'https://uat-hitchregistergw.hellobike.com/api',
      API: 'https://uat-api.hellobike.com/api',
      ROOT_API: 'https://uat-taxiapi.hellobike.com',
      TAXI_API: 'https://uat-taxiapi.hellobike.com/api',
      BACE_API: 'https://uat.rapi.ttbike.com.cn/user/notify',
      HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/uat/latest/index.html',
      MAIN_HOST_API: 'https://m.hellobike.com/AppHitchMainH5/uat/latest/index.html',
      MAIN_H5_PR_IM: 'https://m.hellobike.com/AppHitchMainH5/uat/latest/pr_index_super-im.html',
      UBT_API: 'https://uat-ubt.hellobike.com/yukon_logging',
      UPLOAD_API: 'https://uat-api.hellobike.com/api',
      AUTH_API: 'https://uat-api.hellobike.com/auth',
      CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/uat/latest/index.html#/?h5Login=1&openType=webview',
      CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/uat/latest/index.html',
      CS_WEB_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/uat/latest/index.html?h5Login=1&openType=webview',
      CS_API_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/uat/latest/index.html',
      HITCH_API: 'https://m.hellobike.com/AppHitchDriverApplyH5/uat/latest/index.html',
      ECO_EXPRESS: 'https://uat-ecotaxiapi.hellobike.com/api',
      HITCH_STATION: 'https://uat-spacexapi.hellobike.com/api',
      rongCloudAPPKey: 'c9kqb3rdc4mqj',
      ALIPAY_PAY_H5: 'https://m.hellobike.com/AppH5PayPage/uat/latest/index.html',
      MARKETING_API: 'https://uat-marketingapi.hellobike.com/api',
      APP_RCPDRIVER_EDUCATION_H5: 'https://m.hellobike.com/AppRcpDriverEducationH5/uat/latest/index.html',
      LBS_API: 'https://uat-hello-location-based-services.hellobike.cn/api',
      APP_AUTH_REBIND_PHONE_H5: 'https://m.hellobike.com/AppAuthH5/uat/latest/index.html#/rebind-phone',
      APP_TRANSFER_H5: 'https://m.hellobike.com/AppHitchMainH5/uat/latest/index.html#/transfer',
      // HITCH_REGISTER_API : 'https://hitchregistergw.hellobike.com/api',
      // API: 'https://api.hellobike.com/api',
      // ROOT_API: 'https://taxiapi.hellobike.com',
      // BACE_API: 'https://rapi.ttbike.com.cn/user/notify',
      // HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/latest/index.html',
      // MAIN_HOST_API: 'https://m.hellobike.com/AppHitchMainH5/latest/index.html',
      // UBT_API: 'https://ubt.hellobike.com/yukon_logging',
      // UPLOAD_API: 'https://api.hellobike.com/api',
      // AUTH_API: 'https://api.hellobike.com/auth',
      // CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/latest/index.html#/?h5Login=1&openType=webview',
      // CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/latest/index.html',
      // ECO_EXPRESS: 'https://ecotaxiapi.hellobike.com/api',
      // rongCloudAPPKey: '6tnym1br6pcy7',
    });
  } else if (env === 'pre') {
    Object.assign(config, {
      FREE_RIDE_API: 'https://pre-a.hellobike.com/hitch/api',
      HITCH_REGISTER_API: 'https://pre-hitchregistergw.hellobike.com/api',
      API: 'https://pre-api.hellobike.com/api',
      ROOT_API: 'https://pre-taxiapi.hellobike.com',
      TAXI_API: 'https://pre-taxiapi.hellobike.com/api',
      BACE_API: 'https://pre.rapi.ttbike.com.cn/user/notify',
      HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/pre/latest/index.html',
      MAIN_HOST_API: 'https://m.hellobike.com/AppHitchMainH5/pre/latest/index.html',
      MAIN_H5_PR_IM: 'https://m.hellobike.com/AppHitchMainH5/pre/latest/pr_index_super-im.html',
      UBT_API: 'https://pre-ubt.hellobike.com/yukon_logging',
      UPLOAD_API: 'https://pre-api.hellobike.com/api',
      AUTH_API: 'https://pre-api.hellobike.com/auth',
      CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/pre/latest/index.html#/?h5Login=1&openType=webview',
      CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/pre/latest/index.html',
      CS_WEB_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/pre/latest/index.html?h5Login=1&openType=webview',
      CS_API_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/pre/latest/index.html',
      HITCH_API: 'https://m.hellobike.com/AppHitchDriverApplyH5/pre/latest/index.html',
      ECO_EXPRESS: 'https://pre-ecotaxiapi.hellobike.com/api',
      HITCH_STATION: 'https://pre-spacexapi.hellobike.com/api',
      rongCloudAPPKey: '6tnym1br6pcy7',
      APP_RCPDRIVER_EDUCATION_H5: 'https://m.hellobike.com/AppRcpDriverEducationH5/pre/latest/index.html',
      ALIPAY_PAY_H5: 'https://m.hellobike.com/AppH5PayPage/pre/latest/index.html',
      MARKETING_API: 'https://pre-marketingapi.hellobike.com/api',
      LBS_API: 'https://pre-hello-location-based-services.hellobike.cn/api',
      APP_AUTH_REBIND_PHONE_H5: 'https://m.hellobike.com/AppAuthH5/pre/latest/index.html#/rebind-phone',
      APP_TRANSFER_H5: 'https://m.hellobike.com/AppHitchMainH5/pre/latest/index.html#/transfer',
    });
  } else if (env === 'pro' || env === 'gray') {
    Object.assign(config, {
      FREE_RIDE_API: 'https://a.hellobike.com/hitch/api',
      HITCH_REGISTER_API: 'https://hitchregistergw.hellobike.com/api',
      API: 'https://api.hellobike.com/api',
      ROOT_API: 'https://taxiapi.hellobike.com',
      TAXI_API: 'https://taxiapi.hellobike.com/api',
      BACE_API: 'https://rapi.ttbike.com.cn/user/notify',
      HOST_API: 'https://m2.hellobike.com/AppHelloBikeHitchH5/latest/index.html',
      MAIN_HOST_API: 'https://m.hellobike.com/AppHitchMainH5/latest/index.html',
      MAIN_H5_PR_IM: 'https://m.hellobike.com/AppHitchMainH5/latest/pr_index_super-im.html',
      UBT_API: 'https://ubt.hellobike.com/yukon_logging',
      UPLOAD_API: 'https://api.hellobike.com/api',
      AUTH_API: 'https://api.hellobike.com/auth',
      CS_WEB: 'https://m.hellobike.com/AppHelloBikeCSH5/latest/index.html#/?h5Login=1&openType=webview',
      CS_API: 'https://m.hellobike.com/AppHelloBikeCSH5/latest/index.html',
      CS_WEB_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/latest/index.html?h5Login=1&openType=webview',
      CS_API_NEW: 'https://m.hellobike.com/AppHelloBikeReactH5/latest/index.html',
      HITCH_API: 'https://m.hellobike.com/AppHitchDriverApplyH5/latest/index.html',
      ECO_EXPRESS: 'https://ecotaxiapi.hellobike.com/api',
      HITCH_STATION: 'https://spacexapi.hellobike.com/api',
      rongCloudAPPKey: '6tnym1br6pcy7',
      APP_RCPDRIVER_EDUCATION_H5: 'https://m.hellobike.com/AppRcpDriverEducationH5/latest/index.html',
      ALIPAY_PAY_H5: 'https://m.hellobike.com/AppH5PayPage/latest/index.html',
      MARKETING_API: 'https://marketingapi.hellobike.com/api',
      LBS_API: 'https://hello-location-based-services.hellobike.com/api',
      APP_AUTH_REBIND_PHONE_H5: 'https://m.hellobike.com/AppAuthH5/latest/index.html#/rebind-phone',
      APP_TRANSFER_H5: 'https://m.hellobike.com/AppHitchMainH5/latest/index.html#/transfer',
    });
  }
  config.BASE_API = `${config.ROOT_API}/api`;
};
setConst(_env);

// 区分环境tag
// const sysTag = 'tt-sort-15';
export const getSysTag = () => {
  // eslint-disable-next-line no-unreachable
  if (_env !== 'pro') {
    return window.localStorage.getItem('__sysTag') || undefined;
  }
  if (_env === 'dev') {
    return 'dev';
  } if (_env === 'fat_2') {
    return 'fat_group2';
  } if (_env === 'fat:tag=fat') {
    return 'fat';
  } if (_env === 'gray') {
    return 'gray';
  }
  return undefined;
};
export const setSysTag = (__sysTag) => {
  if (_env !== 'pro') {
    window.localStorage.setItem('__sysTag', __sysTag);
  }
};

config.alipayEcoId = '2021001185685229';
config.alipayAppId = '2016092701982277';
config.weiboAPPKey = '918976056';
config.customizedCardGuid = '00bcbf7e8b4648b282974fff5a7c7250';
// config.BASE_API = `${config.ROOT_API}/api`;
config.wxAppId = 'wxb2315cf308c9a24d'; // 哈啰出行
config.hitchWxAppId = 'wx7a676bd5e6055c02'; // 哈啰顺风车
config.baiduAppId = '25236061'; // 百度顺风车小程序
config.hitchDriverAppId = 'wxabfd42781cb9dd96';// 顺风车车主小程序

export default config;
